<template>
	<v-list class="sidebar-list pa-0 pt-10">

		<v-list-item
			v-for="resourceItem in resourcesItems"
			:key="resourceItem.card_id"
			class="sidebar-list__item"
		>
			<v-list-item-content class="d-flex py-5" style="width: 100%; border-top: 1px solid black; border-color: rgba(0, 0, 0, 0.12);">
				<router-link
					style='width: 100%'
					class="d-flex category-card__title justify-space-between align-center"
					:to="{
								name: 'posts-by-id',
								params: { id: resourceItem.thread_id },
								query: {
									enable_all_comments: resourceItem.allow_comments ? 1 : 0
								}
							}"
				>
					<div style='width: 90%;'>
						<h5 class='mb-2'>{{resourceItem.thread_title}}</h5>
						<div class='d-flex align-center font-weight-regular' style="width: 100%">
							<p
								v-html="resourceItem.thread_text"
								style="font-size: 15px"
								class="ma-0 truncate-2-lines"
							></p>
						</div>
					</div>
					<v-icon
						size='33'
						class='mr-1'
					>
						mdi-chevron-right
					</v-icon>
				</router-link>
			</v-list-item-content>
		</v-list-item>
	</v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
	name: 'BookmarkList',
	data () {
		return {
			fileColors: [
				{ color: '#50bee8', ext: ['jpg', 'jpeg', 'psd'] },
				{ color: '#6678aa', ext: ['bmp'] },
				{ color: '#a066aa', ext: ['png', 'gif'] },
				{ color: '#f15642', ext: ['pdf'] },
				{ color: '#50bee8', ext: ['doc', 'docx'] },
				{ color: '#638674', ext: ['rtf'] },
				{ color: '#f15642', ext: ['ppt'] },
				{ color: '#84bd5a', ext: ['xls', 'xlsx'] },
				{ color: '#f7b84e', ext: ['mp3', 'wav', 'flac'] },
				{ color: '#f7b84e', ext: ['avi', 'mp4', 'mpeg'] },
				{ color: '#576d7e', ext: ['txt'] },
				{ color: '#e59f2b', ext: ['zip', 'rar', '7z', 'gz', 'gzip', 'bzip'] },
				{ color: '#41a8e1', ext: ['url'] },
			],
		}
	},
	props: {
		resourcesItems: {
			type: Array,
			default: () => [],
		}
	},
	computed: {
		...mapGetters('resources', ['resourcesList', 'isLoading', 'listMeta', 'breadCrumbs']),
	},
	methods: {
		...mapActions('resources', ['breadCrumbHandler']),

		folderClickHandler(resourceItem = {}) {
			const {resource_id: id, resources_name: name} = resourceItem

			this.breadCrumbHandler([{id, name}])
		},
		formateBreadCrumbs(resourceId) {
			const listIds = this.breadCrumbs.map(item => item.id)

			if (_.isEmpty(listIds)) {
				return {};
			}

			return {
				bread_crumbs: [...listIds, +resourceId].join(',')
			};
		},
		fileIconColor(file) {
			if (!file.filename) return '#8b8b8b'

			const extName = this.fileIconName(file)
			const colorDataObj = extName && this.fileColors.find((i) => i.ext.indexOf(extName) > -1)

			return colorDataObj ? colorDataObj.color : '#8b8b8b'
		},
		dateCreated(originalDate) {
			const date = new Date(originalDate * 1000)
			const options = { year: 'numeric', month: 'long', day: 'numeric' }
			return date.toLocaleDateString('en-US', options)
		},
		fileIconName(file) {
			if (file.metadata) {
				return (file.filename || '').split('.').pop().substring(0, 4)
			}

			return 'url'
		}
	},
	created() {
		//
	}
}
</script>

<style lang="scss">
.truncate-2-lines {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal;
}
.popular-post-by-category {
	color: #37474f;
	padding: 18px 10px 16px 20px;
	border-radius: 11px;
	margin-bottom: 16px;
	width: 100%;
	background: #e2f2e9;
	box-shadow: none !important;

	&__title {
		padding-bottom: 25px;
		p {
			font-family: Montserrat, sans-serif;
			font-style: normal;
			font-weight: bold;
			font-size: 14px;
			line-height: 17px;
			letter-spacing: 0.35px;
			color: #202232;
		}

		a {
			font-family: Montserrat, sans-serif;
			font-style: normal;
			font-weight: 500;
			font-size: 12px;
			line-height: 15px;
			text-align: center;
			letter-spacing: 0.35px;
			color: #000 !important;
			mix-blend-mode: normal;
			opacity: 0.4;
			text-decoration: none;

			&:hover {
				opacity: 1;
				text-decoration: underline;
			}
		}
	}

	&__thing-title {
		.thing-link {
			font: 500 16px/1.5 'Montserrat';
		}
	}

	&__user-name {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 20px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: #37474f;
		word-break: break-all;
	}
	&__avatar {
		img {
			object-fit: cover;
		}
	}

	&__user-location {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: #37474f;
	}

	&__link {
		font: 500 16px/1.5 'Montserrat';
		text-decoration: none;
		color: #37474f !important;

		&:hover {
			transition: color 0.2s, background-color 0.2s, border-color 0.2s !important;
			color: black !important;
			text-decoration: underline;
		}
	}
}
</style>
